module.exports = __webpack_public_path__ + "img/plus.ffb09e49.png";